import React from 'react';
import PropTypes from 'prop-types';
import reduce from 'lodash/reduce';
import orderBy from 'lodash/orderBy';
import values from 'lodash/values';

const WatchlistsPropTypes = {
  watchlists: PropTypes.object.isRequired,
};

const deduplicateWatchlist = watchlists => {
  if (watchlists && watchlists.matches) {
    // dedup sources taking the highest confidence
    const displayWatchlists = reduce(watchlists.matches, (result, match) => {
      if (
        (!result[match.source] || (result[match.source].confidence < match.confidence))
      ) {
        result[match.source] = match;
      }
      return result;
    }, {});

    // order the watchlists by confidence, source
    const orderDisplayWatchlists = orderBy(values(displayWatchlists), [
      'confidence',
      'source',
    ], ['desc', 'asc']);
    return orderDisplayWatchlists;
  }
  return [];
};

function Watchlists(props) {
  const { watchlists } = props;
  const displayWatchlist = deduplicateWatchlist(watchlists);

  return (
    <div className="watchlists">
      <p className="bold">Watch Lists</p>

      {(displayWatchlist && displayWatchlist.length > 0)
        ? displayWatchlist.map(match => (
          <div key={match.source} className="row small-text grey">
            {match.type ? (
              <div className="col-6">
                <p><strong>{match.type}</strong></p>
              </div>
            ) : false}

            <div className="col">
              <p>
                <strong>{match.source}</strong>
                {' '}
                -
                {' '}
                {match.confidence}
                {' '}
                confidence
              </p>
            </div>
          </div>
        ))
        : <p className="light-grey small-text"><i>No watch list matches found</i></p>}
    </div>
  );
}
Watchlists.propTypes = WatchlistsPropTypes;

export default Watchlists;
